<template>
  <div class="forget-form">
    <h2 class="title">找回密码</h2>
    <a-form
      class="form"
      :form="form"
      :layout="formLayout"
      :labelCol="formItemLayout.labelCol"
      :wrapperCol="formItemLayout.wrapperCol"
    >
      <div v-show="(step === 0)">
        <a-form-item label="">
          <a-input
            ref="inputRef"
            v-decorator="[
              'phone',
              {
                rules: [
                  {
                    type: 'string',
                    pattern: /^[1]([3-9])[0-9]{9}$/,
                    message: '请输入正确手机号'
                  },
                  {
                    required: true,
                    message: '请输入手机号'
                  }
                ]
              }
            ]"
            placeholder="请输入手机号"
            size="large"
          >
            <a-icon slot="prefix" type="mobile" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-decorator="[
              'code',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入短信验证码'
                  }
                ]
              }
            ]"
            placeholder="请输入短信验证码"
            ref="codeInput"
            size="large"
          >
            <a-icon slot="prefix" type="mail" />
            <a-tooltip slot="suffix">
              <a-button
                type="link"
                @click="sendVerificationCode"
                :disabled="codeLoading"
                >{{ codeText }}</a-button
              >
            </a-tooltip>
          </a-input>
        </a-form-item>
      </div>
      <div v-show="step!==0">
        <a-form-item has-feedback label="密码">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入密码'
                  },
                  { min: 8, max: 16, message: '请输入8-16位密码' },
                  {
                    validator: validateToNextPassword,
                  },
                ]
              }
            ]"
            type="password"
            placeholder="请输入密码"
            size="large"
          >
          <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item has-feedback label="确认密码">
          <a-input
            v-decorator="[
              'confirmPassword',
              {
                rules: [
                  {
                    required: true,
                    message: '请确认密码'
                  },
                  {
                    validator: compareToFirstPassword,
                  },
                ]
              }
            ]"
            type="password"
            placeholder="确认密码"
            @blur="handleConfirmBlur"
            size="large"
          >
          <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
      </div>
        <a-form-item style="padding-top:10px;" v-if="step===0">
          <a-button type="primary" size="large" style="width:100%" @click="next"
            >下一步</a-button
          >
        </a-form-item>
        <a-form-item style="padding-top:10px;" v-else>
          <a-button type="primary" size="large" style="width:100%" @click="handleSubmit" :loading="btnLoading">完成</a-button>
        </a-form-item>
        <a-form-item>
          <a-button size="large" style="width:100%" @click="handleCancel">取消</a-button>
        </a-form-item>
    </a-form>
  </div>
</template>

<script>
import loginService from '@/services/login.service'
export default {
  name: 'ForgetForm',
  data () {
    return {
      step: 0,
      codeLoading: false,
      btnLoading: false,
      form: this.$form.createForm(this, { name: 'forget_password_form' }),
      formItemLayout: {
        labelCol: { span: 0 },
        wrapperCol: { span: 24 }
      },
      formLayout: 'horizontal',
      codeText: '发送验证码',
      confirmDirty: false
    }
  },
  methods: {
    // 发送验证码
    sendVerificationCode () {
      this.form.validateFields(['phone'], async (err, values) => {
        if (!err) {
          this.codeLoading = true
          const { status } = await loginService.getForgetCode({
            phone: values.phone
          })
          if (status === 0) {
            this.codeLoading = true
            this.codeText = '60s后重试'
            let time = 60
            let timer = setInterval(() => {
              time--
              this.codeText = `${time}s后重试`
              if (time === 0) {
                this.codeText = '发送验证码'
                this.codeLoading = false
                clearInterval(timer)
              }
            }, 1000)
          } else {
            this.codeLoading = false
          }
        }
      })
    },
    // 下一步
    next () {
      this.form.validateFields(['phone', 'code'], async (err, values) => {
        if (!err) {
          const { status, result } = await loginService.checkCode({
            phone: values.phone,
            code: values.code
          })
          if (status === 0) {
            this.step++
          }
        }
      })
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(new Error('两次密码输入不一致!'))
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    // 完成
    handleSubmit () {
      this.form.validateFields(['password', 'confirmPassword', 'phone', 'code'], async (err, values) => {
        if (!err) {
          this.btnLoading = true
          const { status } = await loginService.setForgetPassword({
            phone: values.phone,
            code: values.code,
            password: values.password
          })
          this.btnLoading = false
          if (status === 0) {
            this.$notification['success']({
              message: '成功',
              description: '密码设置成功，请重新登录'
            })
            this.$emit('cancel')
          }
        }
      })
    },
    // 取消
    handleCancel () {
      this.step = 0
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.forget-form {
  position: absolute;
  width: 35%;
  height: 50%;
  right: 6%;
  top: 24%;
  .title {
    height: 32px;
    font-size: 24px;
    color: rgba(51, 51, 51, 1);
    line-height: 32px;
  }
  .form {
    margin-top: 40px;
  }
}
</style>
